import {Component, ElementRef, Input} from '@angular/core';

@Component({
  selector: 'app-tariff',
  templateUrl: './tariff.component.html',
})
export class TariffComponent {
  @Input() tariffs: Array<{
    title: string,
    speed: string,
    measure: string,
    price: string,
    currency: string,
  }> = [];

  constructor(private elRef: ElementRef) {
  }

  scrollIntoView(): any {
    this.elRef.nativeElement.scrollIntoView();
  }
}
